<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-body>
            <b-button variant="primary" @click="$router.push('/apikeys/add')" class="mb-3">
              <feather-icon icon="PlusIcon" />
              Create API Key
            </b-button>
            <vue-good-table :columns="header" :rows="columnData" @on-row-click="onRowClick" :total-rows="pageTotal" :per-page="pageLength" :pagination-options="{
              enabled: true,
            }">
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap">
                      Showing 1 to
                    </span>
                    <b-form-select v-model="pageLength" :options="[5, 10, 20, 50, 100]" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> of {{ props.total }} entries </span>
                  </div>

                  <b-pagination :value="1" :total-rows="pageTotal" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </template>
            </vue-good-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getApiKeys } from "@/services/ApiKeyService";
import { BButton, BCol, BFormSelect, BModal, BCardBody, BPagination, BRow, BCard } from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
export default {
  name: "ApiKeys",
  components: {
    BRow,
    BCol,
    BPagination,
    BFormSelect,
    BModal,
    VueGoodTable,
    BButton,
    BCardBody,
    BCard,
  },
  data() {
    return {
      pageTotal: 0,
      pageLength: 10,
      columnData: [{}],
      modal: {},
    };
  },
  async mounted() {
    this.columnData = await getApiKeys();
    this.pageTotal = this.columnData.length;
  },
  computed: {
    header() {
      return [
        {
          label: "ID",
          field: "id",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Created At",
          field: "createdAt",
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
          dateOutputFormat: "dd/MM/yyyy HH:mm",
        }
      ];
    },
  },
  methods: {
    onRowClick(e) {
      this.$router.push({ path: `/apikeys/${e.row.id}` });
    },
  },
};
</script>
